export enum Restriction {
  Bio,
  Events,
  Gallery,
  Honor,
}

export class ProfileAccessModel {
  static readonly codeLength: number = 6;
  static readonly allRestrictions: Restriction[] = [Restriction.Bio, Restriction.Gallery, Restriction.Events, Restriction.Honor];

  constructor(
    readonly restrictions: Set<Restriction> = new Set(),
    readonly code: string = '',
  ) {}

  static fullyRestricted(): ProfileAccessModel {
    return new ProfileAccessModel(new Set(this.allRestrictions));
  }

  canAccessHonor(): boolean {
    return !this.restrictions.has(Restriction.Honor);
  }

  canAccessBio(): boolean {
    return !this.restrictions.has(Restriction.Bio);
  }

  canAccessEvents(): boolean {
    return !this.restrictions.has(Restriction.Events);
  }

  canAccessGallery(): boolean {
    return !this.restrictions.has(Restriction.Gallery);
  }

  isValid(): boolean {
    return this.code.length === ProfileAccessModel.codeLength;
  }

  changeCode(code: string): ProfileAccessModel {
    if (this.code === code) return this;
    return new ProfileAccessModel(this.restrictions, code);
  }

  toggleAll(): ProfileAccessModel {
    if (this.isFullyRestricted()) {
      return new ProfileAccessModel(new Set(), this.code);
    } else {
      const allRestrictions = new Set(ProfileAccessModel.allRestrictions);
      return new ProfileAccessModel(allRestrictions, this.code);
    }
  }

  toggle(section: Restriction): ProfileAccessModel {
    const restrictions = new Set(this.restrictions);

    if (restrictions.has(section)) {
      restrictions.delete(section);
    } else {
      restrictions.add(section);
    }

    return new ProfileAccessModel(restrictions, this.code);
  }

  isFullyRestricted(): boolean {
    return this.restrictions.size === ProfileAccessModel.allRestrictions.length;
  }

  equals(other: ProfileAccessModel): boolean {
    const sameRestrictions = Array.from(this.restrictions).every(restriction => other.restrictions.has(restriction));
    return this.code === other.code && this.restrictions.size === other.restrictions.size && sameRestrictions;
  }

  copy(): ProfileAccessModel {
    const restrictions = new Set(this.restrictions);
    return new ProfileAccessModel(restrictions, this.code);
  }
}
